import React, { useCallback, useEffect, useState } from "react";
import BackButton from "../../../components/common/BackButton";
import SingleAppointmentComponent from "./SingleAppointmentComponent";
import noSlotVector from "../../../assets/images/no-slots.svg";

import blueClock from "../../../assets/icons/blue-clock-icon.png";

import { useDispatch, useSelector } from "react-redux";
import { ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { getUrlWithToken } from "../utilityFunctions";
import { logEventWithData } from "../../../app/eventSlice";
import {
  setStateFromPayload,
  navigoShowError,
  getPlanService,
  clearServicePlan,
} from "../navigoSlice";
import { SocialSharing } from "@ionic-native/social-sharing";

import NavigoServices from "../../../services/NavigoServices";
import { NoAppointmentFound } from "./noAppointmentFound";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import GeneralNavigoCard from "./generalNavigoCard";
import { IonContent, IonPage, IonSlide, IonSlides } from "@ionic/react";
import navigoServicesBanner from "../../../assets/images/navigo-services-banner.png";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import CommonHeader from "../../../CommonHeader";

let navigoServicesSwiper7 = null;
const navigoServicesSlideOpts7 = {
  initialSlide: 0,
  speed: 500,

  on: {
    beforeInit() {
      navigoServicesSwiper7 = this;
    },
  },
};

SwiperCore.use([Pagination]);
export default function NavigoFirstSection7({ handleGotoAddress }) {
  const token = useSelector((store) => store.tab.docToken?.token);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const serviceType = queryParams.get("serviceType") || 1;
  const navigoStore = useSelector((store) => store.navigo);
  const user = useSelector((store) => store.login.user);
  const plan = useSelector((state) => state.home.plans);
  const [finalServices, setFinalServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { services, upcomingAppointments, serviceTypeId, loadedPlans, fetchingPlans } =
    navigoStore.ui;
  const { plans, servicePlan } = navigoStore;
  const [selectedPlan, setSelectedPlan] = useState(plans?.length === 1 ? (plans[0]?.name || "") : "");
  const [planId, setPlanId] = useState(plans?.length === 1 ? (plans[0]?.planId || "") : "");
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [isPB, setIsPB] = useState(false);
  // Whether a services fetch has settled for the current plan. Without it the
  // gap between picking a plan and the fetch starting rendered the
  // "No service found" empty state for a frame.
  const [servicesFetched, setServicesFetched] = useState(false);

  useEffect(() => {
    const source = localStorage.getItem("app_source");
    setIsPB(source === "pb");
  }, []);
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile,
  );
  // const serviceType = useSelector((state) => state.service.serviceType);
  // Auto-select the first plan however many there are. Previously only a lone
  // plan was selected and 2+ plans forced the picker modal open on entry; the
  // plan row stays tappable, so switching is still one tap away.
  useEffect(() => {
    if (!plans?.length || planId) return;
    setSelectedPlan(plans[0].name || "");
    setPlanId(plans[0].planId);
  }, [plans]);

  // Declared before the fetch effect so that on a plan change this clears the
  // flag first and the fetch effect can then set it.
  useEffect(() => {
    setServicesFetched(false);
  }, [planId]);
  // Fetch the selected plan's services whenever we have a plan chosen but no
  // services in redux. This single effect covers every entry path:
  //  - initial mount with a pre-selected (single) plan
  //  - returning from the provider screen, where the parent (newIndex.js)
  //    dispatches clearAppointmentAndServices on the location change and wipes
  //    redux `servicePlan` — previously nothing refetched it, so the list went
  //    blank while the plan dropdown (local state) stayed filled.
  // `lastFetchedKeyRef` guards against an infinite loop when a plan genuinely
  // has no services (an empty response leaves servicePlan empty).
  const lastFetchedKeyRef = React.useRef(null);
  useEffect(() => {
    if (!planId) return;
    if (servicePlan.length > 0) {
      // Services are present; clear the guard so a later reset refetches.
      lastFetchedKeyRef.current = null;
      setServicesFetched(true);
      return;
    }
    if (isLoading) return;
    const fetchKey = `${planId}:${serviceType}`;
    if (lastFetchedKeyRef.current === fetchKey) return;
    lastFetchedKeyRef.current = fetchKey;
    setIsLoading(true);
    dispatch(
      getPlanService({
        pageNum: 0,
        pageSize: 0,
        patientId: patientProfile.id,
        planId: planId,
        serviceType: Number(serviceType),
        skipValidation: true,
      }),
    ).finally(() => {
      setIsLoading(false);
      setServicesFetched(true);
    });
  }, [planId, serviceType, servicePlan, isLoading, patientProfile?.id]);

  // Plans are fetched by the parent (newIndex) and land after this mounts, and
  // the services fetch cannot start until a plan is known. Treat that whole
  // run-up as loading — otherwise the first paint is the page shell with an
  // empty body, and the loader only appears once the services call begins.
  const isPreparing =
    !loadedPlans ||
    fetchingPlans ||
    // Deliberately NOT `(!planId && plans.length > 0)`: that state is waiting
    // on the user to pick a plan, not on a fetch, and the plan picker renders
    // in the non-loading branch below. Counting it as loading hid the very
    // modal that sets planId, so the spinner ran forever for any patient with
    // two or more active plans. Entering a /navigo URL directly hits it every
    // time, because the navigo slice is not persisted and plans are always
    // refetched from empty.
    (planId && !servicesFetched);

  useEffect(() => {
    if (!servicePlan?.length) {
      setFinalServices([]);
      return;
    }

    const filteredServices = servicePlan.filter(
      (service) => service.serviceSubTypeId === 3,
    );

    setFinalServices(filteredServices);
  }, [servicePlan]);

  return (
    <IonPage>
      <IonContent>
        {isLoading || isPreparing ? (
          <>
            {isPB && <CommonHeader />}
            <CircularProgress
              className="ion-router-circular-progress"
              style={{ marginTop: "200px" }}
            />
          </>
        ) : (
        <React.Fragment>
          {isPB && <CommonHeader />}
          <div className="navigo-booking-container">
            <div className="navigo-booking-container-back-button">
              {/* <BackButton></BackButton> */}
              <p>{"Book services"}</p>
            </div>
            <div
              className="border px-4 py-3 mx-4 mt-4 rounded cursor-pointer flex justify-between items-center bg-white shadow"
              onClick={() => setIsPlanModalOpen(true)}
            >
              <span className="font-semibold">{selectedPlan ? `Plan: ${selectedPlan}` : "Select a plan"}</span>
              <svg
                className="w-4 h-4 text-gray-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.187l3.71-3.956a.75.75 0 111.08 1.04l-4.25 4.533a.75.75 0 01-1.08 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            {isPlanModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-40 z-100 flex justify-center items-end">
                <div className="w-full bg-white rounded-t-2xl overflow-hidden max-h-[80vh] flex flex-col">
                  <div className="bg-[#E5E8F0] px-4 py-3 flex justify-between items-center border-b">
                    <span className="text-sm font-bold text-[#12194C]">
                      My Active Plans
                    </span>
                    <button
                      onClick={() => setIsPlanModalOpen(false)}
                      className="text-xl font-light text-[#12194C]"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="overflow-y-auto">
                    {plans.map((plan, index) => (
                      <div
                        key={index}
                        className="px-4 py-3 text-[#12194C] border-b cursor-pointer hover:bg-gray-50"
                        onClick={() => {
                          // The fetch effect only runs when redux servicePlan
                          // is empty, so without this the previous plan's
                          // services stayed on screen under the new plan name.
                          if (plan.planId !== planId) {
                            dispatch(clearServicePlan());
                          }
                          setSelectedPlan(plan.name);
                          setPlanId(plan.planId);
                          setIsPlanModalOpen(false);
                        }}
                      >
                        {plan.name}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="navigo-booking-container-section-2">
              {finalServices && finalServices.length > 0 && (
                <div>
                  {finalServices.map((service, index) => {
                    return (
                      <GeneralNavigoCard
                        service={service}
                        handleGotoAddress={handleGotoAddress}
                        planId={planId}
                        pageType={7}
                      />
                    );
                  })}
                </div>
              )}
              {planId && servicesFetched && finalServices.length === 0 && (
                <div className="navigo-booking-container-section-2-no-service">
                  <img src={noSlotVector} alt="bg-img" />
                  <p>No service found.</p>
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
        )}
      </IonContent>
    </IonPage>
  );
}
